var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.is_loading)?_c('div',{staticClass:"loading"}):_vm._e(),_c('datatable',{attrs:{"title":"Company Educations","unique_buttons":_vm.unique_buttons,"fields":_vm.fields,"response":_vm.data},on:{"create":_vm.createEducation,"delete":_vm.deleteEducation,"edit_click":_vm.editClick,"override":_vm.override,"delete_all":_vm.deleteAll}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }